{
  "userMenu": {
    "logout": {}
  }
}
